'use client'

import { useEffect } from 'react'
import { useLocation } from 'react-router'

/**
 * ScrollToTop component that scrolls to the top of the page
 * whenever the route changes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    // Use setTimeout to ensure DOM is fully rendered
    const timer = setTimeout(() => {
      // Try multiple methods to ensure scroll works
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' as ScrollBehavior
      })
      
      // Fallback methods
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      
      // Also scroll any scrollable containers
      const scrollableElements = document.querySelectorAll('[data-scroll-container]')
      scrollableElements.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.scrollTop = 0
        }
      })
    }, 0)

    return () => clearTimeout(timer)
  }, [pathname])

  return null
}
